import { BoundaryComponent } from "../BoundaryComponent";
import { default as CCHChartV1 } from "./v1";
import { default as CCHChartV2 } from "./v2";

const CCHChart = (props) => {
  return BoundaryComponent(props, [CCHChartV2, CCHChartV1]);
}

export default CCHChart;